var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 22.3327C1.77718 20.7969 3.14382 19.5349 4.75415 18.6613C6.36449 17.7877 8.16752 17.3301 9.99957 17.3301C11.8316 17.3301 13.6347 17.7877 15.245 18.6613C16.8553 19.5349 18.222 20.7969 19.2208 22.3327",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 14.666C12.9449 14.666 15.3327 11.7559 15.3327 8.16602C15.3327 4.57616 12.9449 1.66602 9.99935 1.66602C7.05383 1.66602 4.66602 4.57616 4.66602 8.16602C4.66602 11.7559 7.05383 14.666 9.99935 14.666Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUser);
export default __webpack_public_path__ + "static/media/single-user.b60f96e841e98603fcc5a1551327ebb0.svg";
export { ForwardRef as ReactComponent };